import { apiService } from 'core/services/apiService';

export interface PermissionGroup {
	'@id': string;
	'@type': string;
	id: number;
	label: string;
}

export interface Permission {
	'@id': string;
	'@type': string;
	id: number;
	label: string;
	description: string | null;
	permissionGroup: PermissionGroup;
}

export interface GetPermissionsParams {
	page?: number;
	itemsPerPage?: number;
}

export interface PermissionsResponse {
	items: Permission[];
	total: number;
}

export const PERMISSION_FUNCTIONS = ['view', 'edit', 'delete', 'execute'];

/**
 * Get permissions with pagination
 */
export const getPermissions = async (
	params: GetPermissionsParams = {}
): Promise<PermissionsResponse> => {
	try {
		const { page = 1, itemsPerPage = 50 } = params;
		const queryParams = { page, itemsPerPage };
		const response = apiService.responseHandler(
			await apiService.get('/permissions', {
				params: queryParams,
			})
		);
		// console.log('permissions', response);
		// Handle response - assuming API returns { items, total }
		const permissionsData = response.member;

		return { items: permissionsData, total: permissionsData.length };

		return { items: [], total: 0 };
	} catch (error: any) {
		console.error('Failed to fetch permissions:', error);
		return { items: [], total: 0 };
	}
};

// Export as service object
export const permissionsService = {
	getPermissions,
};

export default permissionsService;
